import React from "react";
import { Card, Avatar, Typography } from "antd";
import Headshot from "../Player/Headshot";

const { Text } = Typography;

export const PlayerInfo = React.memo(
	({
		playerName,
		playerInitials,
		playerData,
		headshot,
		team_logo,
		useOverlay,
	}) => (
		<div
			style={{
				display: "flex",
				gap: "1rem",
				alignItems: "center",
			}}
		>
			{!headshot && !team_logo ? (
				<Avatar
					size={100}
					src={playerData?.profilePicture}
					style={{
						backgroundColor: !playerData?.profilePicture
							? "#f56a00"
							: "transparent",
						fontSize: "3rem",
					}}
				>
					{!playerData?.profilePicture && playerInitials}
				</Avatar>
			) : (
				<div style={{ width: "31.25rem" }}>
					<Headshot
						headshot={headshot}
						team_logo={team_logo}
						useOverlay={useOverlay}
					/>
				</div>
			)}

			<Card
				style={{ minWidth: "12rem", maxWidth: "15rem" ,height: "14.75rem" }}
				bodyStyle={{ padding: "0.75rem", height: "100%" }}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "start",
						height: "100%",
						alignItems: "start",
					}}
				>
					<Text>
						<Text strong>Name:</Text> {playerName}
					</Text>
					
					{//TODO: uncomment this once we get the
					/* <Text>
						<Text strong>Height:</Text> {playerData?.height}
					</Text>
					<Text>
						<Text strong>Current Weight:</Text> {playerData?.weight}
					</Text>
					<Text>
						<Text strong>Class:</Text> {playerData?.class}
					</Text> */}
					<Text>
						<Text strong>Jersey Number:</Text> {playerData?.number}
					</Text>
					<Text>
						<Text strong>Position:</Text> {playerData?.position}
					</Text>
					{/* <Text>
						<Text strong>Hometown:</Text> {playerData?.hometown}
					</Text> */}
				</div>
			</Card>
		</div>
	)
);
